import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import DataCollectionPage2UI from './DataCollectionPage2UI.js'

class DataCollectionPage2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      account: null,
      itrFileList: null,
      gstFileList: null,
      bsFileList: null,
      npFileList: null,
      mcaFileList: null,
      bankAccountList: [],
      copyToClipboardText: null
    }
  }

  render() {
    return (
      <DataCollectionPage2UI
        context={this.props.context}
        errorList={this.state.errorList}
        account={this.state.account}
        itrFileList={this.state.itrFileList}
        gstFileList={this.state.gstFileList}
        bsFileList={this.state.bsFileList}
        npFileList={this.state.npFileList}
        mcaFileList={this.state.mcaFileList}
        bankAccountList={this.state.bankAccountList}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        onRefreshClick={this.onRefreshClick}
        onAccountUpdate={this.onAccountUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getCompanyReports(context)
    this.getClientBankAccounts(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getCompanyReports = (context) => {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/companyReports/files`,
      cacheKey: CacheKeys.CompanyReports(this.props.match.params.accountId),
      callback: this.getCompanyReportsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCompanyReportsCallback = (response) => {
    this.setState({
      itrFileList: response.itrFileList,
      gstFileList: response.gstFileList,
      bsFileList: response.bsFileList,
      npFileList: response.npFileList,
      mcaFileList: response.mcaFileList
    })
  }

  getClientBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/clientBankAccounts/info`,
      cacheKey: CacheKeys.ClientBankAccounts(this.props.match.params.accountId),
      callback: this.getClientBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getClientBankAccountsCallback = (response) => {
    this.setState({ bankAccountList: response.bankAccountList })
  }

  onAccountUpdate = (account) => {
    let loan = this.state.loan
    loan.account = account
    this.setState({ account: account })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.CompanyReports(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.ClientBankAccounts(this.props.match.params.accountId))
    this.setState({
      account: null,
      itrFileList: null,
      gstFileList: null,
      bsFileList: null,
      npFileList: null,
      mcaFileList: null,
      bankAccountList: null
    },
      this.getAccounts(context),
      this.getCompanyReports(context),
      this.getClientBankAccounts(context)
    )
  }
}

export default withRouter(DataCollectionPage2SF)
